import { SignMessRequests } from 'domain-models/SignMessRequests';
import { Crypto } from 'libraries/Crypto';
import { Helper } from 'libraries/Helper';
import MultistringUtils from 'libraries/MultistringUtils';
import { Page } from 'libraries/Page';

export class SignMessRequestsBo {
	private static salt = 'ipRPCMHCo2kJ';

	static CreateClearRequest(id: number, username: string): SignMessRequests {
		var clearRequest = new SignMessRequests();
		clearRequest.Beacons = false;
		clearRequest.ControllerUserName = username;
		clearRequest.DeviceId = id;
		clearRequest.Duration = '838:59:59';
		clearRequest.HashedMessage = '';
		clearRequest.Message = '';
		clearRequest.PriorityId = 7;
		clearRequest.RequestType = 'Clear';
		clearRequest.StatusId = 13;
		clearRequest.TimeProcessed = Helper.FormateDate(new Date());
		clearRequest.TimeRequested = Helper.FormateDate(new Date());
		clearRequest.Timestamp = Helper.FormateDate(new Date());
		return clearRequest;
	}

	static async CreateSubmitRequest(
		deviceId: number,
		priorityId: number,
		priorityLevel: number,
		statusId: number,
		requestType: string,
		pages: Page[],
		selectedDuration: string,
		choosenDate: Date,
		beacons: boolean,
		controllerUserName: string,
		ignoreBadWords: boolean = false
	): Promise<SignMessRequests> {
		var request = new SignMessRequests();
		request.DeviceId = deviceId;
		request.PriorityId = priorityId;
		request.StatusId = statusId; // value from StatusNames table 13 is Requested
		request.RequestType = requestType; // value based on the button click event (send/clear/status?)

		var now = new Date();
		request.TimeRequested = Helper.FormateDate(now);
		request.TimeProcessed = Helper.FormateDate(now);
		request.Timestamp = Helper.FormateDate(now);
		request.PriorityLevel = priorityLevel;

		request.Message = MultistringUtils.construct(pages);
		request.HashedMessage = await Crypto.HashWithSalt(
			request.Message + request.TimeRequested,
			this.salt
		);
		request.ignoreBadWords = ignoreBadWords;
		//console.log(request.HashedMessage);
		if (selectedDuration == 'Infinite') {
			//TODO get the max value of minutes as timespan
			request.Duration = '838:59:59'; //This used to be: 838:59:59
		} else {
			request.Duration = Helper.TimeToDuration(choosenDate);
		}
		request.Beacons = beacons;
		request.ControllerUserName = controllerUserName;

		return request;
	}

	static CreatePollRequest(id: number, username: string): SignMessRequests {
		var pollRequest = new SignMessRequests();
		pollRequest.Beacons = false;
		pollRequest.ControllerUserName = username;
		pollRequest.DeviceId = id;
		pollRequest.Duration = '838:59:59';
		pollRequest.HashedMessage = '';
		pollRequest.Message = '';
		pollRequest.PriorityId = 7;
		pollRequest.RequestType = 'Poll';
		pollRequest.StatusId = 13;
		pollRequest.TimeProcessed = Helper.FormateDate(new Date());
		pollRequest.TimeRequested = Helper.FormateDate(new Date());
		pollRequest.Timestamp = Helper.FormateDate(new Date());
		return pollRequest;
	}

	static GetMultistring(pages: Page[]): string {
		let multistring = '';
		console.log('Pages on multistring', pages);
		pages.forEach((page) => {
			if (!page.IsEmpty()) {
				//TO-DO
				//if it is only one page then do not put flash on flash off
				multistring += '[pt' + page.flashOn + 'o' + page.flashOff + ']';
				//TO-DO!!!
				//validate not adding [np] on the first page or on if it is only one page... Check GetMultiString() on DmsControlLogic.cs on namespace ODOT.OU.ITS.Libraries.Device.Sign.Dms
				if (true) {
					multistring += '[np]';
				}
				page.lines.forEach((line) => {
					multistring += '[fo' + line.font.Id + ']' + line.text + '[nl]';
				});
			}
		});

		console.log(multistring);
		return multistring;
	}

	static async hashMe(mess) {
		//var p ="VGY&bhu8";
		//var t = 'VhZnUbz1XIh6GXw6Bahvj2VCEKLhPQwkENY7Zr74vxk=';
		//hashed should be +UsgmoQJ7faF/U1j2KJ3r2ftS8b2+7s3kEuaCQXHmIY=
		var r = await Crypto.HashWithSalt(mess, this.salt);
		console.log(r);
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/bll/SignMessRequestsBo.ts